import learnerRedPandasExperiments from 'bundles/epic/clients/learnerRedPandas';

export const isWeekLandingEnabled = (courseId: string) =>
  learnerRedPandasExperiments.get('weeksLandingPage', { course_id: courseId });
